import React, { useContext } from "react";
import { Row, Col } from "react-grid-system";
import parLogo from "images/purdue-logo-footer.webp";
import ablrBadgeOne from "images/ablr-badge-1.webp";
import ablrBadgeTwo from "images/ablr-badge-2.webp";
import ExternalLink from "../../external-link";
import { appContext } from "providers/appProvider";

function Footer() {
    const { appConfigs } = useContext(appContext);
    return (
        <footer>
            <div className="footer-content centered-content-lg">
                <Row align="start" justify="between">
                    <Col lg={7.1} sm={12}>
                        <LinksBlock appConfigs={appConfigs} />
                        <div className="ablr-badges mobile-only">
                            <div className="ablr-badges__logo">
                                <ExternalLink
                                    externalURL="https://ablr360.com/badging-program/"
                                    messageTitle={
                                        appConfigs.externalLinkInfo.TITLE
                                    }
                                    messageBody={
                                        appConfigs.externalLinkInfo.BODY
                                    }
                                    classNameLink="normal-link link ablr"
                                    classNameOverlay={
                                        appConfigs.externalLinkInfo
                                            .OVERLAY_CLASS_NAME
                                    }
                                >
                                    <img
                                        src={ablrBadgeOne}
                                        alt="Ablr Badge One logo"
                                    />
                                </ExternalLink>
                            </div>
                            <div className="ablr-badges__logo">
                                <ExternalLink
                                    externalURL="https://ablr360.com/badging-program/"
                                    messageTitle={
                                        appConfigs.externalLinkInfo.TITLE
                                    }
                                    messageBody={
                                        appConfigs.externalLinkInfo.BODY
                                    }
                                    classNameLink="normal-link link ablr"
                                    classNameOverlay={
                                        appConfigs.externalLinkInfo
                                            .OVERLAY_CLASS_NAME
                                    }
                                >
                                    <img
                                        src={ablrBadgeTwo}
                                        alt="Ablr Badge Two logo"
                                    />
                                </ExternalLink>
                            </div>
                        </div>
                    </Col>
                    <Col lg={4.7} sm={12}>
                        {/* <br /> */}
                        <div className="footer-content__block">
                            <p className="copyright-text no-btm-spacer">
                                We are committed to maintaining the highest
                                standards of sales and marketing practices,
                                while continuing to advance the proper treatment
                                of patients. If you have any questions or
                                concerns with our sales and marketing practices,
                                please contact us at 1-877-787-3831.
                            </p>
                            <div className="footer-purdue-logo">
                                <img
                                    src={parLogo}
                                    alt="Purdue Logo"
                                    className="logo-par"
                                />
                            </div>
                            <br />
                            <p className="copyright-text no-btm-spacer">
                                &copy;2024 Purdue Pharma L.P. All Rights
                                Reserved.
                                <br />
                                The vector plus with tail is a trademark of
                                Purdue Pharma L.P. <br />
                                All other trademarks are the property of their
                                respective owners.
                                <br />
                                Intended for residents of the United States
                                only.
                                <br />
                                MR–08410&nbsp;&nbsp;04/24
                            </p>
                        </div>
                    </Col>
                </Row>
            </div>
        </footer>
    );
}

const LinksBlock = ({ appConfigs }) => (
    <>
        <Row justify="between">
            <Col sm={12} md={5.25} lg={5.5} xl={5}>
                <div className="links-block footer-nav-links">
                    <ul>
                        <li>
                            <a
                                href="https://www.purduepharma.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                PurduePharma.com
                            </a>
                        </li>

                        <li>
                            <ExternalLink
                                externalURL="https://dailymed.nlm.nih.gov/dailymed/fda/fdaDrugXsl.cfm?setid=3abfbffc-9e52-4fc6-ae92-6e0a97f4afe7&type=display"
                                messageTitle={
                                    appConfigs.externalLinkInfoPI.TITLE
                                }
                                messageBody={appConfigs.externalLinkInfoPI.BODY}
                                classNameLink="normal-link link"
                                classNameOverlay={
                                    appConfigs.externalLinkInfoPI
                                        .OVERLAY_CLASS_NAME
                                }
                            >
                                Full Prescribing Information
                            </ExternalLink>
                        </li>

                        <li>
                            <a
                                href="https://www.purduepharma.com/healthcare-professionals/ask-purdue-medical/#report-adverse-event/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Report an Adverse Event
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://www.purduepharma.com/healthcare-professionals/ask-purdue-medical/#report-adverse-event/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Product Quality Complaint
                            </a>
                        </li>

                        <li>
                            <a
                                id="clarip-do-not-sell-link"
                                href="#"
                                rel="noopener noreferrer"
                                tabIndex={0}
                            >
                                Do Not Sell My Information
                            </a>
                        </li>

                        <li>
                            <a
                                href="../pdfs/Purdue_Pharma_Nalmefene_Accessibility_Conformance_Report_04.2024.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Accessibility Statement
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="ablr-badges desktop-only">
                    <div className="ablr-badges__logo">
                        <ExternalLink
                            externalURL="https://ablr360.com/badging-program/"
                            messageTitle={appConfigs.externalLinkInfo.TITLE}
                            messageBody={appConfigs.externalLinkInfo.BODY}
                            classNameLink="normal-link link ablr"
                            classNameOverlay={
                                appConfigs.externalLinkInfo.OVERLAY_CLASS_NAME
                            }
                        >
                            <img src={ablrBadgeOne} alt="Ablr Badge One logo" />
                        </ExternalLink>
                    </div>
                    <div className="ablr-badges__logo">
                        <ExternalLink
                            externalURL="https://ablr360.com/badging-program/"
                            messageTitle={appConfigs.externalLinkInfo.TITLE}
                            messageBody={appConfigs.externalLinkInfo.BODY}
                            classNameLink="normal-link link ablr"
                            classNameOverlay={
                                appConfigs.externalLinkInfo.OVERLAY_CLASS_NAME
                            }
                        >
                            <img src={ablrBadgeTwo} alt="Ablr Badge Two logo" />
                        </ExternalLink>
                    </div>
                </div>
            </Col>
            <Col sm={12} md={6.5} lg={6} xl={6.5}>
                <div className="links-block footer-ext-links">
                    <ul>
                        <li>
                            <a
                                href="https://www.purduepharma.com/contact-us/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Contact Us
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://www.purduepharma.com/legal"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Terms and Conditions
                            </a>
                        </li>

                        <li>
                            <a
                                href="https://www.purduepharma.com/about/ethics-and-compliance/ccpa/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Privacy Policy
                            </a>
                        </li>

                        <li>
                            <a
                                href="/pdfs/MR-07876-Information_for_Colorado_Prescribers_of_Prescription_Drugs-nalmefene_vial.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Information for Colorado Prescribers{" "}
                            </a>
                        </li>

                        <li>
                            <a
                                href="/pdfs/MR-08440-Information_for_CT_Prescribers-nalmefene_hydrochloride_injection.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Information for Connecticut Prescribers{" "}
                            </a>
                        </li>

                        <li>
                            <a href="/sitemap/">Sitemap</a>
                        </li>
                    </ul>
                </div>
            </Col>
        </Row>
    </>
);

export default Footer;
